import {Box, HStack, type Integer, Show, VStack} from 'platform/foundation';

import {SkeletonLoadingBox} from '@dms/shared';

export interface CustomerInsightsSectionSkeletonProps {
  skeletonHeight: Integer;
  skeletonVariant: 'identity' | 'record';
}

const SKELETON_BACKGROUND_COLOR = 'palettes.neutral.30.100' as const;

export function CustomerInsightsSectionSkeleton(props: CustomerInsightsSectionSkeletonProps) {
  const primaryLineHeight = props.skeletonVariant === 'identity' ? 4 : 2;

  return (
    <Box>
      <HStack spacing={3} align="center">
        <Show when={props.skeletonVariant === 'record'}>
          <Box>
            <SkeletonLoadingBox
              isLoading
              width={props.skeletonHeight}
              height={props.skeletonHeight}
              borderRadius="small"
              backgroundColor={SKELETON_BACKGROUND_COLOR}
            />
          </Box>
        </Show>
        <VStack spacing={2} minWidth={0} grow={1}>
          <Box>
            <SkeletonLoadingBox
              isLoading
              width={36}
              height={primaryLineHeight}
              borderRadius="small"
              backgroundColor={SKELETON_BACKGROUND_COLOR}
            />
          </Box>
          <Box>
            <SkeletonLoadingBox
              isLoading
              width={24}
              height={2}
              borderRadius="small"
              backgroundColor={SKELETON_BACKGROUND_COLOR}
            />
          </Box>
        </VStack>
      </HStack>
    </Box>
  );
}
